/* Bella Flor 2026 · movimiento. Sin librerias: IntersectionObserver + rAF. */
(() => {
  const quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Revelado al entrar en pantalla (con retraso escalonado por grupo)
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => {
    ents.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function preparar(raiz = document) {
    raiz.querySelectorAll('[data-bf-grupo]').forEach((g) => {
      g.querySelectorAll('[data-bf-revela]').forEach((el, i) => el.style.setProperty('--bf-retraso', `${Math.min(i, 8) * 0.09}s`));
    });
    raiz.querySelectorAll('[data-bf-revela], [data-bf-observa]').forEach((el) => {
      if (quieto || !io) el.classList.add('is-visible'); else io.observe(el);
    });
  }

  // Hero: fundido entre fotos con zoom lento
  function hero(raiz = document) {
    raiz.querySelectorAll('[data-bf-hero]').forEach((h) => {
      const slides = [...h.querySelectorAll('.bf-hero__slide')];
      const puntos = [...h.querySelectorAll('.bf-hero__punto')];
      if (!slides.length) return;
      let i = 0, t;
      const ir = (n) => {
        slides[i].classList.remove('is-on'); puntos[i]?.classList.remove('is-on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-on');
        if (puntos[i]) { puntos[i].classList.remove('is-on'); void puntos[i].offsetWidth; puntos[i].classList.add('is-on'); }
      };
      const auto = () => { clearInterval(t); if (!quieto && slides.length > 1) t = setInterval(() => ir(i + 1), 6500); };
      puntos.forEach((p, n) => p.addEventListener('click', () => { ir(n); auto(); }));
      requestAnimationFrame(() => { slides[0].classList.add('is-on'); puntos[0]?.classList.add('is-on'); h.classList.add('is-visible'); });
      auto();
    });
  }

  // Parallax suave en imagenes marcadas
  function parallax() {
    const els = [...document.querySelectorAll('[data-bf-parallax]')];
    if (!els.length || quieto) return;
    let pend = false;
    const paso = () => {
      pend = false;
      const vh = window.innerHeight;
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
        el.style.setProperty('--bf-par', `${(-p * 6).toFixed(2)}%`);
      });
    };
    window.addEventListener('scroll', () => { if (!pend) { pend = true; requestAnimationFrame(paso); } }, { passive: true });
    paso();
  }

  // Barra de llamar: aparece despues de la portada
  function barra() {
    const b = document.querySelector('.bf-llamar');
    if (!b) return;
    const ver = () => b.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.5);
    window.addEventListener('scroll', ver, { passive: true }); ver();
  }

  const todo = (raiz) => { preparar(raiz); hero(raiz); };
  document.addEventListener('DOMContentLoaded', () => { todo(document); parallax(); barra(); });
  // Editor de temas de Shopify: re-inicializar la seccion que se recarga
  document.addEventListener('shopify:section:load', (e) => todo(e.target));
})();

/* Bella Flor 2026 · adicionales: se anaden junto con el arreglo en una sola operacion */
(() => {
  const seccionesCarrito = () => {
    const d = document.querySelector('cart-drawer');
    return d ? d.getSectionsToRender().map((s) => s.id) : [];
  };
  async function anadir(items, origen) {
    const secciones = seccionesCarrito();
    const r = await fetch(`${window.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: secciones, sections_url: window.location.pathname }),
    });
    const datos = await r.json();
    if (!r.ok || datos.status) throw new Error(datos.description || datos.message || 'No se pudo añadir');
    const d = document.querySelector('cart-drawer');
    if (d && datos.sections) {
      d.classList.contains('is-empty') && d.classList.remove('is-empty');
      d.renderContents(datos);
    } else {
      window.location = window.routes.cart_url;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: origen, cartData: datos });
  }

  // 1) En el producto: si hay adicionales marcados, el boton "Agregar" los lleva junto con el arreglo
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    const tabla = document.querySelector('[data-bf-adicionales]');
    const marcados = tabla ? [...tabla.querySelectorAll('[data-bf-addon]:checked')] : [];
    if (!marcados.length) return; // sin adicionales: Dawn sigue como siempre
    e.preventDefault(); e.stopImmediatePropagation();
    const boton = form.querySelector('[type="submit"]');
    boton && boton.setAttribute('aria-disabled', 'true'); boton && boton.classList.add('loading');
    const id = Number(form.querySelector('[name="id"]').value);
    const cant = Number((document.querySelector(`input[name="quantity"][form="${form.id}"]`) || form.querySelector('[name="quantity"]') || { value: 1 }).value) || 1;
    const para = tabla.dataset.para;
    const items = [{ id, quantity: cant }].concat(marcados.map((m) => ({ id: Number(m.dataset.bfAddon), quantity: 1, properties: { Para: para } })));
    try { await anadir(items, 'product-form'); marcados.forEach((m) => (m.checked = false)); }
    catch (err) { alert(err.message); }
    finally { boton && boton.removeAttribute('aria-disabled'); boton && boton.classList.remove('loading'); }
  }, true);

  // 2) En el carrito: boton "Anadir" de las sugerencias
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-bf-sugerir]');
    if (!b) return;
    e.preventDefault(); b.disabled = true; b.textContent = 'Añadiendo…';
    try { await anadir([{ id: Number(b.dataset.bfSugerir), quantity: 1 }], 'bf-sugerencias'); }
    catch (err) { b.disabled = false; b.textContent = 'Añadir'; alert(err.message); }
  });
})();
